import { EmailSettings } from './EmailSettings';
import { MessageTriggers } from './MessageTriggers';
import { SmsSettings } from './SmsSettings';

/** Settings → Email & SMS: how the business sends, then which messages go out and how. */
export function MessagingSettings() {
  return (
    <div className="stack">
      <EmailSettings />
      <SmsSettings />
      <MessageTriggers />
    </div>
  );
}
